/* eslint-disable no-use-before-define, arrow-body-style, class-methods-use-this */
import Component from '@bythepixel/component-loader';
import { GoogleObserver, RecaptchaObserver } from './Observers';
import {
  EventHandler,
  FormHandler,
  PaginationHandler,
  SortHandler,
} from './Handlers';
import DEFAULTS from './options';
import SelectorMapping from './SelectorMapping';
import Events from './events';

export default class GoogleSearchController extends Component {
  static selector = DEFAULTS.componentSelector;

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    const { selectors } = options;

    this.searchContentContainer = this.$container.querySelector(
      selectors.searchContentContainer,
    );

    this.FormHandler = new FormHandler(selectors.formHandler);
    this.GoogleObserver = new GoogleObserver();
    this.SortHandler = new SortHandler();
    this.PaginationHandler = new PaginationHandler();
    RecaptchaObserver.watch();

    this.mount();
  }

  isMobile() {
    const { userAgent, maxTouchPoints } = window.navigator;
    const hasTouchPoints = maxTouchPoints > 0;

    return userAgent.match('(M|m)obile') && hasTouchPoints;
  }

  get searchStatus() {
    return this.$container.dataset.compGoogleSearchResultsStatus;
  }

  set searchStatus(updatedValue) {
    this.$container.dataset.compGoogleSearchResultsStatus = updatedValue;
  }

  get resultsRendered() {
    return this.$container.dataset.compGoogleSearchResultsRendered === true;
  }

  set resultsRendered(updatedValue) {
    this.$container.dataset.compGoogleSearchResultsRendered = updatedValue;
  }

  async forwardSearchToGoogle(searchString) {
    const { $container } = this;

    const [inputSelector, submitBtnSelector] = SelectorMapping.get(
      'gsc-form__input',
      'gsc-form__submit-btn',
    );

    if (!inputSelector || !submitBtnSelector) {
      this.handleError(new Error('Required selectors not found for search'));
      return;
    }

    const input = $container.querySelector(inputSelector);
    const submitBtn = $container.querySelector(submitBtnSelector);

    if (!input || !submitBtn) {
      this.handleError(new Error('Required elements not found for search'));
      return;
    }

    input.value = searchString;
    submitBtn.click();

    await this.waitForGoogleResults();
  }

  async waitForGoogleResults() {
    const resultsControlWrapper = this.$container.querySelector(
      SelectorMapping.get('gsc-misc__control-wrapper'),
    );

    try {
      await this.GoogleObserver.watchFor(
        resultsControlWrapper,
        () => !resultsControlWrapper.classList.contains('gsc-loading-fade'),
        {
          attributes: true,
          childList: false,
          subtree: false,
          attributeOldValue: true,
        },
      );

      window.dispatchEvent(Events.ResultsLoadedEvent);
    } catch (error) {
      this.handleError(error);
    }
  }

  showSearchResults() {
    const { searchContentContainer } = this;
    const resultsContainerSelector = SelectorMapping.get(
      'gsc-results__container',
    );
    const resultsContainer = this.$container.querySelector(
      resultsContainerSelector,
    );

    searchContentContainer.innerHTML = '';
    searchContentContainer.appendChild(resultsContainer);
  }

  removeTimestampFromResults() {
    const { $container } = this;
    const resultsInfoSelector = SelectorMapping.get(
      'gsc-results__result-count',
    );
    const pattern = /\s+\(.+\)/i;
    const resultsEl = $container.querySelector(resultsInfoSelector);
    const text = resultsEl?.textContent;

    if (!text) {
      return;
    }

    resultsEl.textContent = text.replace(pattern, '');
  }

  async googleFormReady() {
    const formSelector = SelectorMapping.get('gsc-form');
    const { $container } = this;

    try {
      await this.GoogleObserver.watchFor(
        $container,
        () => $container.querySelector(formSelector) || false,
      );
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError(error) {
    console.error(
      'GoogleSearchController | An unexpected error occurred. Exiting gracefully.\n\n',
      error,
    );

    this.FormHandler.remove();
  }

  async mount() {
    this.EventHandler = new EventHandler(this);

    if (this.isMobile()) {
      this.$container.dataset.compGoogleSearchIsMobile = true;
    }

    try {
      await this.googleFormReady();

      this.FormHandler.enable();
    } catch (error) {
      this.handleError(error);
    }
  }
}
